<template>
  <div class="activity-box">
    <div class="main">
      <img class="bg" src="./images/bg.png" alt="" />
      <div class="time">時間：2024年10月22日0：00-10月31日24:00</div>
      <div class="progress-box">
        <div class="value" :style="{ width: lastHpWidth }"></div>
        <span class="hp-text">當前血量：{{ hp }}</span>
      </div>
      <div class="video-box">
        <video
          data-v-c4afa4bc=""
          src="./images/dragon.mp4"
          autoplay="autoplay"
          loop="loop"
          muted="muted"
          class="banner-item banner-video"
          style="width: 913px; height: 627px;"
        ></video>
      </div>
      <img
        class="tab"
        src="./images/tab1-active.jpg"
        alt=""
        v-show="activeIndex === 1"
        @click="checkScoreList(1)"
      />
      <img
        class="tab"
        src="./images/tab1.jpg"
        alt=""
        v-show="activeIndex === 2"
        @click="checkScoreList(1)"
      />
      <img
        class="tab2"
        src="./images/tab2.jpg"
        alt=""
        v-show="activeIndex === 1"
        @click="checkScoreList(2)"
      />
      <img
        class="tab2"
        src="./images/tab2-active.png"
        alt=""
        v-show="activeIndex === 2"
        @click="checkScoreList(2)"
      />
      <div class="total-prize">{{ pool || 0 }}</div>
      <div class="damage">{{ score || 0 }}</div>
      <div class="ranking">{{ userRank || '---' }}</div>
      <!-- <div class="previous" @click="getPrevious()" v-if="batch > 1">上一條</div>
      <div class="next" @click="getNext()" v-if="batch < nowBatch">下一條</div> -->
      <div class="top3-box" v-show="activeIndex === 1">
        <div
          v-for="(item, index) of userTopList"
          :key="item.userUuid"
          class="item"
          :class="`top${index + 1}`"
          @click="toPlayerDetail(item.userUuid)"
        >
          <template v-if="item && item.userUuid">
            <img :src="item.avatarUrl" class="head-portrait" />
            <div class="user-name">{{ item.nickname }}</div>
            <div class="score">{{ item.score }}</div>
          </template>
        </div>
      </div>
      <div class="score-board-box" v-show="activeIndex === 1">
        <div
          class="item"
          v-for="(item, i) of userList.slice(3, 10)"
          :key="item.userUuid"
          :class="`item${i + 3}`"
          @click="toPlayerDetail(item.userUuid)"
        >
          <template v-if="item && item.userUuid">
            <div class="left">
              <img :src="item.avatarUrl" alt="排名頭像" class="" />
              <span class="user-name">{{ item.nickname }}</span>
            </div>
            <div class="right">
              <span class="scroe">傷害{{ item.score || '--' }}</span>
            </div>
          </template>
        </div>
      </div>
      <div class="top3-box" v-show="activeIndex === 2">
        <div
          v-for="(item, index) of voiceRoomTopList"
          :key="item.userUuid"
          class="item"
          :class="`top${index + 1}`"
          @click="toVoiceRoom(item.userUuid)"
        >
          <template v-if="item && item.userUuid">
            <img :src="item.avatarUrl" class="head-portrait" />
            <div class="user-name">{{ item.nickname }}</div>
            <div class="score">{{ item.score }}</div>
          </template>
        </div>
      </div>
      <div class="score-board-box" v-show="activeIndex === 2">
        <div
          class="item"
          v-for="(item, i) of voiceRoomList.slice(3, 10)"
          :key="item.userUuid"
          :class="`item${i + 3}`"
          @click="toVoiceRoom(item.userUuid)"
        >
          <template v-if="item && item.userUuid">
            <div class="left">
              <img :src="item.avatarUrl" alt="排名頭像" class="" />
              <span class="user-name">{{ item.nickname }}</span>
            </div>
            <div class="right">
              <span class="scroe">傷害{{ item.score || '--' }}</span>
            </div>
          </template>
        </div>
      </div>
      <ul class="prize prize1">
        <li class="item" v-for="(item, index) of prizeList[0]" :key="index">
          <img :src="item.url" alt="" />
          <div class="name">{{ item.name }}</div>
        </li>
      </ul>
      <ul class="prize prize2">
        <li class="item" v-for="(item, index) of prizeList[1]" :key="index">
          <img :src="item.url" alt="" />
          <div class="name">{{ item.name }}</div>
        </li>
      </ul>
      <ul class="prize prize3">
        <li class="item" v-for="(item, index) of prizeList[2]" :key="index">
          <img :src="item.url" alt="" />
          <div class="name">{{ item.name }}</div>
        </li>
      </ul>
      <ul class="prize prize4">
        <li class="item" v-for="(item, index) of prizeList[3]" :key="index">
          <img :src="item.url" alt="" />
          <div class="name">{{ item.name }}</div>
        </li>
      </ul>
      <ul class="prize prize5">
        <li class="item" v-for="(item, index) of prizeList[4]" :key="index">
          <img :src="item.url" alt="" />
          <div class="name">{{ item.name }}</div>
        </li>
      </ul>
      <ul class="prize prize6">
        <li class="item" v-for="(item, index) of prizeList[5]" :key="index">
          <img :src="item.url" alt="" />
          <div class="name">{{ item.name }}</div>
        </li>
      </ul>
      <ul class="prize prize7">
        <li
          class="item"
          v-for="(item, index) of voiceRoomRankList[0]"
          :key="index"
        >
          <img :src="item.url" alt="" />
          <div class="name">{{ item.name }}</div>
        </li>
      </ul>
      <ul class="prize prize8">
        <li
          class="item"
          v-for="(item, index) of voiceRoomRankList[1]"
          :key="index"
        >
          <img :src="item.url" alt="" />
          <div class="name">{{ item.name }}</div>
        </li>
      </ul>
      <ul class="prize prize9">
        <li
          class="item"
          v-for="(item, index) of voiceRoomRankList[2]"
          :key="index"
        >
          <img :src="item.url" alt="" />
          <div class="name">{{ item.name }}</div>
        </li>
      </ul>
      <ul class="prize dressup">
        <li class="item" v-for="(item, index) of dressupList" :key="index">
          <img :src="item.url" alt="" />
          <div class="name">{{ item.name }}</div>
        </li>
      </ul>
      <p class="rules">
        1.活動時間：2024年10月22日0：00-10月31日24:00。 <br />
        2.玩家送禮物將對BOSS造成傷害值1鑽=1傷害值，同時BOSS的獎池會逐漸增加。<br />
        3.本次活動榜單為縂榜單，分爲個人榜單（屠龍英雄榜）和廳榜單。<br />
        4.個人榜單前10和廳榜單前三均有大量獎勵。<br />
        5.將與活動結束后根據縂榜單排名進行排行獎勵發放，三個工作日内到賬。<br />
        6.活動期間玩家送禮有概率爆出禮物、裝扮、會員積分等獎勵，詳見“獎池内容”<br />
        7.對活動有疑問或建議請聯係客服。 <br />
        8.平台保留最終解釋權。
      </p>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import scoreJpg from './images/score.jpg';
import niceNumberJpg from './images/nice-number.jpg';
import firstSrceenPng from './images/first-screen.png';
import topJpg from './images/top.jpg';
import dressJpg from './images/dress.jpg';

export default {
  name: 'SlayingDragons',
  data() {
    return {
      userList: [],
      voiceRoomList: [],
      activeIndex: 1,
      pool: 0,
      score: 0,
      userRank: 0,
      batch: 0,
      nowBatch: 0, //当前正进行的屠龙活动批次
      hp: 0,
      totalHp: 0,
      loading: false,
      dressupList: [
        {
          name: '低保發了',
          url: 'https://resource.3uplay.com/sys-feed/b47781d4.gif'
        },
        {
          name: '黃粱一夢',
          url: 'https://resource.3uplay.com/sys-feed/9dd7e3d4.gif'
        },
        {
          name: '粉角',
          url: 'https://resource.3uplay.com/sys-feed/531c6128.webp'
        },
        {
          name: '會員積分',
          url: scoreJpg
        },
        {
          name: '愛心',
          url: 'https://resource.3uplay.com/user-static/6aaed285.png'
        },
        {
          name: '魔法飛帽',
          url: 'https://resource.3uplay.com/user-static/7d946751.png'
        },
        {
          name: '魔鏡',
          url: 'https://resource.3uplay.com/user-static/d7f66672.png'
        },
        {
          name: '手捧禮盒',
          url: 'https://resource.3uplay.com/user-static/a1b8d560.png'
        },
        {
          name: '666',
          url: 'https://resource.3uplay.com/user-static/9d7c395b.png'
        },
        {
          name: '玉鐲',
          url: 'https://resource.3uplay.com/user-static/8acacf15.png'
        },
        {
          name: '小惡魔',
          url: 'https://resource.3uplay.com/user-static/1a96af1e.png'
        },
        {
          name: '生日蛋糕',
          url: 'https://resource.3uplay.com/user-static/ceeb1365.png'
        }
      ],
      prizeList: [
        [
          {
            url: 'https://resource.3uplay.com/user-static/1682a4d3.png',
            name: '甜夢飛星'
          },
          {
            url: 'https://resource.3uplay.com/user-static/85670464.png',
            name: '金色波動*30天'
          },
          {
            url: 'https://resource.3uplay.com/user-static/01dfd848.png',
            name: '龍嘯蒼穹*30天' //座騎
          },
          {
            url: 'https://resource.3uplay.com/user-static/00a70a50.png',
            name: '金龍進場*30天' //進場
          },
          {
            url: 'https://resource.3uplay.com/sys-feed/df57df44.gif',
            name: '重點色英短*30天' //掛件
          },
          {
            url: scoreJpg,
            name: '會員積分28888'
          }
        ],
        [
          {
            url: 'https://resource.3uplay.com/user-static/4ab3604c.png',
            name: '星海綻放'
          },
          {
            url: 'https://resource.3uplay.com/user-static/eb142e3a.png',
            name: '白色星光*20天'
          },
          {
            url: 'https://resource.3uplay.com/user-static/01dfd848.png',
            name: '龍嘯蒼穹*20天'
          },
          {
            url: 'https://resource.3uplay.com/user-static/00a70a50.png',
            name: '金龍進場*20天'
          },
          {
            url: 'https://resource.3uplay.com/sys-feed/df57df44.gif',
            name: '重點色英短*20天'
          },
          {
            url: scoreJpg,
            name: '會員積分18888'
          }
        ],
        [
          {
            url: 'https://resource.3uplay.com/user-static/c470ed12.png',
            name: '浪漫告白'
          },
          {
            url: 'https://resource.3uplay.com/user-static/eb142e3a.png',
            name: '白色星光*10天'
          },
          {
            url: 'https://resource.3uplay.com/user-static/01dfd848.png',
            name: '龍嘯蒼穹*10天'
          },
          {
            url: 'https://resource.3uplay.com/user-static/00a70a50.png',
            name: '金龍進場*10天'
          },
          {
            url: 'https://resource.3uplay.com/sys-feed/df57df44.gif',
            name: '重點色英短*10天'
          },
          {
            url: scoreJpg,
            name: '會員積分8888'
          }
        ],
        [
          {
            url: 'https://resource.3uplay.com/user-static/4ce34e6e.png',
            name: '浪漫摩天輪'
          },
          {
            url: 'https://resource.3uplay.com/user-static/eb142e3a.png',
            name: '白色星光*7天'
          },
          {
            url: 'https://resource.3uplay.com/user-static/01dfd848.png',
            name: '龍嘯蒼穹*7天'
          },
          {
            url: 'https://resource.3uplay.com/user-static/00a70a50.png',
            name: '金龍進場*7天'
          },
          {
            url: 'https://resource.3uplay.com/sys-feed/df57df44.gif',
            name: '重點色英短*7天'
          },
          {
            url: scoreJpg,
            name: '會員積分6666'
          }
        ],
        [
          {
            url: 'https://resource.3uplay.com/user-static/39b1c049.png',
            name: '織夢戀歌'
          },
          {
            url: 'https://resource.3uplay.com/user-static/eb142e3a.png',
            name: '白色星光*7天'
          },
          {
            url: 'https://resource.3uplay.com/user-static/01dfd848.png',
            name: '龍嘯蒼穹*7天'
          },
          {
            url: 'https://resource.3uplay.com/user-static/00a70a50.png',
            name: '金龍進場*7天'
          },
          {
            url: 'https://resource.3uplay.com/sys-feed/df57df44.gif',
            name: '重點色英短*7天'
          },
          {
            url: scoreJpg,
            name: '會員積分5200'
          }
        ],
        [
          {
            url: 'https://resource.3uplay.com/user-static/65181946.png',
            name: '花嫁'
          },
          {
            url: 'https://resource.3uplay.com/user-static/eb142e3a.png',
            name: '白色星光*5天'
          },
          {
            url: 'https://resource.3uplay.com/user-static/01dfd848.png',
            name: '龍嘯蒼穹*5天'
          },
          {
            url: 'https://resource.3uplay.com/user-static/00a70a50.png',
            name: '金龍進場*5天'
          },
          {
            url: 'https://resource.3uplay.com/sys-feed/df57df44.gif',
            name: '重點色英短*5天'
          },
          {
            url: scoreJpg,
            name: '會員積分1888'
          }
        ]
      ],
      voiceRoomRankList: [
        [
          {
            url: niceNumberJpg,
            name: '4位廳靚號'
          },
          {
            url: firstSrceenPng,
            name: 'APP開屏推薦*3天'
          },
          {
            url: dressJpg,
            name: '廳裝扮額度*100天'
          },
          {
            url: 'https://resource.3uplay.com/user-static/01dfd848.png',
            name: '龍嘯蒼穹*30天'
          },
          {
            url: 'https://resource.3uplay.com/sys-feed/7c2f3137.webp',
            name: '3星水晶氣泡*100天'
          },
          {
            url: 'https://resource.3uplay.com/sys-feed/121f7474.webp',
            name: '3星水晶*100天'
          }
        ],
        [
          {
            url: niceNumberJpg,
            name: '5位廳靚號'
          },
          {
            url: topJpg,
            name: '廳置頂位*3天'
          },
          {
            url: dressJpg,
            name: '廳裝扮額度*50天'
          },
          {
            url: 'https://resource.3uplay.com/user-static/01dfd848.png',
            name: '龍嘯蒼穹*20天'
          },
          {
            url: 'https://resource.3uplay.com/sys-feed/4b544a4c.webp',
            name: '2星水晶氣泡*80天'
          },
          {
            url: 'https://resource.3uplay.com/sys-feed/e591dd7b.webp',
            name: '2星水晶*80天'
          }
        ],
        [
          {
            url: niceNumberJpg,
            name: '6位廳靚號'
          },
          {
            url: topJpg,
            name: '廳置頂位*1天'
          },
          {
            url: dressJpg,
            name: '廳裝扮額度*30天'
          },
          {
            url: 'https://resource.3uplay.com/user-static/01dfd848.png',
            name: '龍嘯蒼穹*10天'
          },
          {
            url: 'https://resource.3uplay.com/sys-feed/18b6b879.webp',
            name: '1星水晶氣泡*70天'
          },
          {
            url: 'https://resource.3uplay.com/sys-feed/95de49ac.webp',
            name: '1星水晶*70天'
          }
        ]
      ]
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    uuid() {
      return this.userInfo ? this.userInfo.uuid : '';
    },
    userTopList() {
      return this.userList && this.userList.length
        ? [this.userList[1], this.userList[0], this.userList[2]]
        : [{}, {}, {}];
    },
    voiceRoomTopList() {
      return this.voiceRoomList && this.voiceRoomList.length
        ? [this.voiceRoomList[1], this.voiceRoomList[0], this.voiceRoomList[2]]
        : [{}, {}, {}];
    },
    lastHpWidth() {
      if (this.hp != undefined && this.totalHp) {
        return this.hp > 0
          ? `calc(${((this.totalHp - this.hp) / this.totalHp) * 100}%)`
          : 0;
      } else {
        return 0;
      }
    }
  },
  watch: {
    uuid: {
      handler: function(val) {
        if (val) {
          this.getDetail(val);
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async getDetail() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      try {
        const { data } = await this.$http.get('/activity/dragonInfo', {
          batch: this.batch
        });
        if (data) {
          this.score = data.score;
          this.userRank = data.rank;
          this.pool = data.pool;
          this.hp = data.hp;
          this.userList = data.userRank;
          this.voiceRoomList = data.roomRank;
          this.totalHp = data.hpTotal;
          for (let i = 0; i < 10; i++) {
            if (!this.userList[i]) {
              this.userList[i] = {};
            }
            if (!this.voiceRoomList[i]) {
              this.voiceRoomList[i] = {};
            }
          }
          this.nowBatch = this.batch === 0 ? data.batch : this.nowBatch;
          this.batch = data.batch;
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    toPlayerDetail(userUuid) {
      this.$router.push({
        path: `/player-detail/${userUuid}`
      });
    },
    checkScoreList(index) {
      this.activeIndex = index;
    },
    getPrevious() {
      if (this.loading) {
        return;
      } else {
        if (this.batch > 1) {
          this.batch -= 1;
          this.getDetail();
        }
      }
    },
    getNext() {
      if (this.loading) {
        return;
      } else {
        if (this.batch < this.nowBatch) {
          this.batch += 1;
          this.getDetail();
        } else {
          this.$message('下一條龍還未降臨！');
        }
      }
    },
    toVoiceRoom(roomUid) {
      window.open(`/voice-room/${roomUid}`, '_blank');
    }
  },
  created() {}
};
</script>
<style lang="scss" scoped>
.activity-box {
  width: 100%;
  background-color: #0d102f;
  overflow: auto;
  text-align: center;
  .main {
    position: relative;
    display: inline-block;
    width: 980px;
    text-align: left;
    > .bg {
      width: 100%;
    }
    .total-prize {
      position: absolute;
      top: 1627px;
      left: 492px;
      font-size: 30px;
      color: #1b67e5;
      width: 150px;
      text-align: center;
    }
    .damage {
      position: absolute;
      top: 1796px;
      color: #271b6a;
      left: 290px;
      font-size: 40px;
    }
    .ranking {
      position: absolute;
      top: 1796px;
      color: #271b6a;
      left: 738px;
      font-size: 40px;
    }
    .tab,
    .tab2 {
      position: absolute;
      top: 1923px;
      width: 405px;
      height: auto;
    }
    .tab {
      left: 80px;
    }
    .tab2 {
      right: 80px;
    }
    .top3-box {
      position: absolute;
      top: 2215px;
      display: flex;
      left: 67px;
      justify-content: space-around;
      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 24px;
        flex: none;
        color: #fffde4;
        width: 232px;
        img {
          border-radius: 50%;
          object-fit: cover;
          width: 214px;
          height: 214px;
        }
        .user-name,
        .score {
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          width: 100%;
          text-align: center;
          opacity: 0.9;
          font-weight: 400;
        }
        .user-name {
          margin-top: 120px;
          font-weight: bold;
          font-size: 42px;
          color: white;
        }
        .score {
          margin-top: dPx(5);
          font-size: 24px;
          opacity: 0.9;
          font-weight: 400;
          color: white;
        }
        &.top1 {
          margin-right: 63px;
        }
        &.top2 {
          width: 250px;
        }
        &.top1,
        &.top3 {
          margin-top: 149px;
        }
        &.top2 {
          margin-right: 65px;
          img {
            width: 228px;
            height: 228px;
          }
        }
      }
    }
    .score-board-box {
      position: absolute;
      top: 2931px;
      left: 74px;
      width: 832px;
      overflow: auto;
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */
      &::-webkit-scrollbar {
        display: none;
      }
      .item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: 190px;
        font-size: 28px;
        margin-bottom: 41px;
        color: #1b67e5;
        border-radius: 40px;
        padding: 0 40px 0 52px;
        // &.item8 {
        //   height: 180px;
        //   margin-bottom: 23px;
        // }
        .left,
        .right {
          display: flex;
          align-items: center;
        }
        .right {
          margin-left: 30px;
        }
        .left {
          .index {
            margin-left: dPx(24);
            margin-right: 88px;
            width: 30px;
            text-align: right;
          }
          img {
            width: 130px;
            height: 130px;
            border-radius: 50%;
            margin-right: dPx(26);
            object-fit: cover;
          }
          .user-name {
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            width: 284px;
            font-weight: bold;
          }
        }
        .right {
          img {
            width: 36px;
            margin: 0 0 0 14px;
          }
        }
      }
    }
  }
  .video-box {
    position: absolute;
    top: 945px;
    height: 562px;
    overflow: hidden;
    width: 910px;
    left: 35px;
    border-radius: 28px;
  }
  .progress-box {
    position: absolute;
    top: 857px;
    height: 35px;
    width: 939px;
    left: 24px;
    border-radius: 23px;
    background: linear-gradient(to right, #2bfb29, #fe0700);
    overflow: hidden;
    .hp-text {
      color: white;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 3;
    }
    .value {
      background-color: #0c1130;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
    }
  }
  .previous,
  .next {
    position: absolute;
    top: 2166px;
    width: 100px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid white;
    color: white;
    border-radius: 20px;
    cursor: pointer;
  }
  .previous {
    left: 144px;
  }
  .next {
    right: 130px;
  }
  // .dressup {
  //   display: flex;
  //   position: absolute;
  //   top: 4806px;
  //   width: 910px;
  //   flex-wrap: wrap;
  //   left: 42px;
  //   .item {
  //     width: 170px;
  //     height: 191px;
  //     margin-right: 12px;
  //     margin-bottom: 30px;
  //     display: flex;
  //     align-items: center;
  //     justify-content: center;
  //     img {
  //       width: 100%;
  //       height: auto;
  //       max-height: 100%;
  //     }
  //   }
  // }
  .prize {
    display: flex;
    position: absolute;
    width: appSizeToWeb(512);
    flex-wrap: wrap;
    left: appSizeToWeb(131);
    .item {
      width: appSizeToWeb(148);
      height: appSizeToWeb(144);
      margin-right: appSizeToWeb(21);
      margin-bottom: appSizeToWeb(31);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      padding: 0 appSizeToWeb(6);
      img {
        width: auto;
        height: appSizeToWeb(114);
        max-width: 100%;
        object-fit: contain;
      }
      .name {
        font-size: appSizeToWeb(14);
        height: appSizeToWeb(22);
        line-height: appSizeToWeb(22);
        color: white;
        width: 100%;
        overflow: hidden;
        text-align: center;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    &.dressup {
      top: appSizeToWeb(8014);
      width: 910px;
      left: appSizeToWeb(49);
      .item {
        width: appSizeToWeb(147);
        height: appSizeToWeb(144);
        margin-right: appSizeToWeb(21);
        margin-bottom: appSizeToWeb(37);
      }
    }
    &.prize1 {
      top: appSizeToWeb(3731);
    }
    &.prize2 {
      top: appSizeToWeb(4155);
    }
    &.prize3 {
      top: appSizeToWeb(4577);
    }
    &.prize4 {
      top: appSizeToWeb(5052);
    }
    &.prize5 {
      top: appSizeToWeb(5508);
    }
    &.prize6 {
      top: appSizeToWeb(5944);
    }
    &.prize7 {
      top: appSizeToWeb(6576);
    }
    &.prize8 {
      top: appSizeToWeb(7000);
    }
    &.prize9 {
      top: appSizeToWeb(7423);
    }
  }
  .time {
    position: absolute;
    top: 601px;
    font-size: 26px;
    color: #ed89fb;
    text-shadow: 1px 1px 1px white;
    left: 140px;
    line-height: 2.3;
    width: 705px;
    text-align: center;
  }
  .rules {
    position: absolute;
    top: appSizeToWeb(8713);
    font-size: 24px;
    color: #a2d3fd;
    left: 67px;
    line-height: 2.6;
  }
}
</style>
